export default __webpack_public_path__ + "static/media/locked-diary.517d1191.png";